import { TaskStatus } from '../api';

export interface StatusMeta {
  key: TaskStatus;
  label: string;
  color: string;
  bg: string;
}

export const STATUSES: StatusMeta[] = [
  { key: 'not_started', label: 'Not Started', color: '#6b7280', bg: '#f3f4f6' },
  { key: 'started', label: 'Started', color: '#2563eb', bg: '#eff6ff' },
  { key: 'in_progress', label: 'In Progress', color: '#d97706', bg: '#fffbeb' },
  { key: 'blocked', label: 'Blocked', color: '#dc2626', bg: '#fef2f2' },
  { key: 'complete', label: 'Complete', color: '#16a34a', bg: '#f0fdf4' },
];

export function statusMeta(key: string): StatusMeta {
  return STATUSES.find((s) => s.key === key) || STATUSES[0];
}
